import { createContext, useContext, FC, ReactNode } from "react";
import type { Brand } from "../types";

/**
 * HERE AND NOW AI Branding Configuration
 * CORRECT branding for UPI Payment Gateway
 */
const defaultBranding: Brand = {
  organizationName: "HERE AND NOW AI",
  website: "https://hereandnowai.com",
  email: "info@hereandnowai.com",
  mobile: "+91 996 296 1000",
  slogan: "AI is Good",
  colors: {
    primary: "#FFDF00", // Yellow
    secondary: "#004040", // Teal
  },
  logo: {
    title:
      "https://raw.githubusercontent.com/hereandnowai/images/refs/heads/main/logos/logo-of-here-and-now-ai.png",
    favicon:
      "https://raw.githubusercontent.com/hereandnowai/images/refs/heads/main/logos/favicon-logo-with-name.png",
  },
  socialMedia: {
    blog: "https://hereandnowai.com/blog",
    linkedin: "https://www.linkedin.com/company/hereandnowai/",
    instagram: "https://instagram.com/hereandnow_ai",
    github: "https://github.com/hereandnowai",
    x: "https://x.com/hereandnow_ai",
    youtube: "https://youtube.com/@hereandnow_ai",
  },
};

// Context
const BrandingContext = createContext<Brand>(defaultBranding);

// Provider component
interface BrandingProviderProps {
  children: ReactNode;
  branding?: Brand;
}

export const BrandingProvider: FC<BrandingProviderProps> = ({
  children,
  branding = defaultBranding,
}) => {
  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
};

// Hook to use branding
export const useBranding = (): Brand => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error("useBranding must be used within a BrandingProvider");
  }
  return context;
};

export default BrandingContext;
